import { useLayoutEffect } from 'react';

/** 地图容器尺寸变化时同步 ECharts canvas，并在回调中刷新 geo 视口 */
const useStatisticsMapContainerResize = (mapWrapRef, chartRef, { enabled = false, onSynced } = {}) => {
	useLayoutEffect(() => {
		if (!enabled) return undefined;

		const wrap = mapWrapRef.current;
		if (!wrap) return undefined;

		const syncChartSize = () => {
			const chart = chartRef.current?.getEchartsInstance?.();
			if (!chart || chart.isDisposed?.()) return;

			const chartEl = wrap.querySelector('.statistics-chart-frame__chart');
			if (!chartEl) return;

			const { width, height } = chartEl.getBoundingClientRect();
			if (width <= 0 || height <= 0) return;

			chart.resize({ width, height });
			onSynced?.(chart);
		};

		syncChartSize();

		const observer = new ResizeObserver(() => {
			requestAnimationFrame(syncChartSize);
		});
		observer.observe(wrap);

		return () => observer.disconnect();
	}, [chartRef, enabled, mapWrapRef, onSynced]);
};

export default useStatisticsMapContainerResize;
